module.exports = __webpack_public_path__ + "img/second_trophy.9a4c4869.svg";